import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tiritas',
  templateUrl: './tiritas.component.html',
  styleUrls: ['./tiritas.component.css']
})
export class tiritasComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
